import { useEffect, useState } from 'react';
import { CalendarDays, ClipboardList, ChevronDown } from 'lucide-react';
import { getTeaching, TeachingClass } from '../api';
import Attendance from '../../classes/components/Attendance';
import { Skeleton } from '../../../components/Skeleton';
import EmptyState from '../../../components/EmptyState';
import MyTasksPanel from '../../tasks/MyTasksPanel';
import { colorClase } from '../../../utils/classColor';
import { horarioCorto } from '../../../utils/horario';

export default function TeacherClasses() {
  const [data, setData] = useState<TeachingClass[] | null>(null);
  const [open, setOpen] = useState<number | null>(null);
  useEffect(() => { getTeaching().then((r) => setData(r.data)).catch(() => setData([])); }, []);

  if (!data) return <div className="space-y-3">{[0, 1, 2].map((i) => <Skeleton key={i} className="h-20 rounded-2xl" />)}</div>;

  return (
    <div className="space-y-4">
      {/* Mis tareas: solo se pinta si el profesor tiene pendientes asignadas */}
      <MyTasksPanel />
      <div>
        <h1 className="font-display text-xl font-bold text-content">Mis clases</h1>
        <p className="mt-0.5 text-sm text-content-3">Toca una clase para pasar lista.</p>
      </div>

      {data.length === 0 ? (
        <EmptyState icon={CalendarDays} title="No tienes clases asignadas" subtitle="Habla con administración." />
      ) : (
        <div className="space-y-3">
          {data.map((c) => (
            <div key={c.class_id} className="overflow-hidden rounded-2xl border border-line bg-surface shadow-sm">
              <button onClick={() => setOpen(open === c.class_id ? null : c.class_id)}
                className="flex w-full items-center gap-3 p-4 text-left transition hover:bg-surface-2/50">
                <span className="h-10 w-1.5 shrink-0 rounded-full" style={{ background: colorClase(c.color) }} />
                <div className="min-w-0 flex-1">
                  <div className="truncate font-display font-bold text-content">{c.name}</div>
                  <div className="truncate text-xs text-content-3">
                    {c.style || '—'} · {c.enrolled}{c.capacity ? `/${c.capacity}` : ''} alumnos
                    {horarioCorto(c.schedule) && ` · ${horarioCorto(c.schedule, ' · ')}`}
                  </div>
                </div>
                <span className="inline-flex shrink-0 items-center gap-1 text-xs font-medium text-brand-blue">
                  <ClipboardList size={14} /> Lista
                  <ChevronDown size={15} className={`transition ${open === c.class_id ? 'rotate-180' : ''}`} />
                </span>
              </button>
              {open === c.class_id && (
                <div className="border-t border-line p-4">
                  <Attendance classId={c.class_id} />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
